import { Navigate } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { INVENTORY_PAGE_KEYS } from "../config/consolePermissionKeys";
import { canAccessApplicationsHub } from "../config/applicationHubPermissions";
import { useAuth } from "../context/AuthContext";
import { Dashboard } from "./Dashboard";

const PLANNING_HOME: { key: string; to: string }[] = [
  { key: "milestone_templates", to: "/milestone-master" },
  { key: "construction_timeline", to: "/construction-timeline-master" },
  { key: "standard_resources", to: "/standard-resources-master" },
];

const INVENTORY_HOME: { key: (typeof INVENTORY_PAGE_KEYS)[number]; to: string }[] = [
  { key: "inventory_issue_po", to: "/inventory/po-register" },
  { key: "inventory_issue_material", to: "/inventory/issue-material" },
  { key: "inventory_inward", to: "/inventory/inward" },
  { key: "inventory_goods_receipts", to: "/inventory/goods-receipts" },
  { key: "inventory_store_stocks", to: "/inventory/store-stocks" },
  { key: "inventory_outward", to: "/inventory/outward" },
  { key: "inventory_stores_yards", to: "/inventory/stores-yards" },
];

/** Default home: dashboard when allowed; otherwise first permitted module. */
export function HomeEntry() {
  const { can } = useAuth();

  if (can("applications")) {
    return <Dashboard />;
  }
  if (canAccessApplicationsHub(can)) {
    return <Navigate to="/applications" replace />;
  }
  if (can("leads")) {
    return <Navigate to="/leads" replace />;
  }
  if (can("leads_import")) {
    return <Navigate to="/leads?import=1" replace />;
  }
  if (can("reports")) {
    return <Navigate to="/reports" replace />;
  }
  if (can("subcontractor_masters")) {
    return <Navigate to="/subcontractor-onboarding" replace />;
  }
  if (can("agents")) {
    return <Navigate to="/agent-master" replace />;
  }
  if (can("geo_directory") || can("geo_directory_admin")) {
    return <Navigate to="/geo-directory" replace />;
  }
  for (const { key, to } of PLANNING_HOME) {
    if (can(key)) {
      return <Navigate to={to} replace />;
    }
  }
  if (can("geo_zones")) {
    return <Navigate to="/zones" replace />;
  }
  if (can("bills_inward")) {
    return <Navigate to="/bills/inward" replace />;
  }
  if (can("bills_outward")) {
    return <Navigate to="/bills/outward" replace />;
  }
  for (const { key, to } of INVENTORY_HOME) {
    if (can(key)) {
      return <Navigate to={to} replace />;
    }
  }

  return (
    <div className="workspace">
      <PageHeader breadcrumb={[{ label: "Home", to: "/" }]} title="No module access" />
      <p className="tab-intro">Your admin account has no permissions assigned. Ask a superadmin to grant access.</p>
    </div>
  );
}
